// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nu-0";